import {useOutletContext} from "react-router-dom";
import {ViewDocumentsSubPage} from "base/file/components";

const ViewPermitExtensionDocumentsSubPage = () => {
    let permit;
    [permit] = useOutletContext();

    return (
        permit && (
            <ViewDocumentsSubPage
                entity={permit}
                basePath={"/permits/extensions/list"}
                disabled
            />
        )
    );
};

export default ViewPermitExtensionDocumentsSubPage;
